//#region IMPORT
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { AuthButton, Button } from '../../../../Components/MUIs';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './SER_BASIC_ColumnDefs';
//#endregionF

function SER_BASIC(props) {
  //#region 변수
  const selectedCustNm =
    props.searchInfo?.custList?.find(
      (c) => String(c.value) === String(props.searchInfo?.custCd || '')
    )?.name || '';
  //#endregion
  const columnDefs1 = getColumnDefs1(props);
  //#region 나머지 함수

  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SeriousAccidentAct"
          searchYn="Y"
          saveYn="Y"
          addYn="Y"
          printYn="N"
          addClick={() => {
            props.HandleEvaluateAddLogic?.();
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            props.setSearchText?.(e);
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            props.SaveLogic1();
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (!props.selectedRowData1?.length) {
              props.PrintLogic1();
              return;
            }
            props.selectedRowData1.forEach((item, index) => {
              props.PrintLogic1(item);
            });
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchInfo?.coList || [],
                    value: props.searchInfo?.coCd || '',
                    onChange: async (e) => {
                      await props.handleCoChange(e);

                      props.SearchLogic1();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo?.custList || [],
              value: props.searchInfo?.custCd || '',
              onChange: async (e) => {
                await props.handleCustChange(e);

                await props.SearchLogic1();
              },
            },
          ]}
          other1={
            <>
              <Button
                name="평가표 관리"
                variant="outlined"
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                onClick={() => props.HandleTemplateManageLogic?.()}
              />
              <Button
                name="일괄 엑셀다운로드"
                variant="outlined"
                sx={{ color: '#2CA900', borderColor: '#2CA900' }}
                onClick={() => {
                  if (!props.validateSelection()) return;
                  props.ExcelDownloadAllLogic?.();
                }}
              />
            </>
          }
          grids={
            <BusinessGridCommon
              gridId={props.gridId1}
              rowSelection={'multiple'}
              // rowId 있어야 삭제 로직 정상 작동
              getRowId={(params) => {
                return params.data.no;
              }}
              deleteYn1={'Y'}
              addClick1={() => {
                props.HandleEvaluateAddLogic?.();
              }}
              deleteClick1={(e) => {
                if (!props.validateSelection()) return;

                const newRowExists = props.selectedRowData1.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion1(props.selectedRowData1);
                } else {
                  props.NewYnErrorMsg();
                }
              }}
              refreshClick1={() => {
                if (!props.validateSelection()) return;

                props.SearchLogic1();
              }}
              gridRef={props.gridRef1}
              columnDefs={columnDefs1}
              rowData={props.rowData1}
              onCellClicked={(e) => {
                // 필요 시 특정 행 선택 등 처리
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;

                const isCheckboxClick = e.event?.target?.type === 'checkbox';

                if (!isCheckboxClick) {
                  gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                  gridApi.setFocusedCell(clickedRowIndex, 'coNm');

                  const copied = JSON.parse(JSON.stringify(e.data));
                  props.handleRowSelection(copied, clickedRowIndex);

                  gridApi
                    .getDisplayedRowAtIndex(clickedRowIndex)
                    ?.setSelected(true, false);
                }

                // 체크박스 컬럼이 아닐때만 cellCLick 실행
                if (e.colDef.field !== 'no') {
                  props.NavigateToDetailLogic?.({
                    screenMode: 'evaluate',
                    formCode: String(e.data?.versionId ?? e.data?.formCode ?? ''),
                    formVer: String(e.data?.versionNo ?? e.data?.formVer ?? ''),
                    versionId: e.data?.versionId,
                    data: e.data,
                  });
                }
              }}
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.selectedRowNosRef.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData1(selectedData);
              }}
              setChangedRowData={props.setChangedRowData1}
              setSelectedRowData={props.setSelectedRowData1}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default SER_BASIC;
